import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { FnSuppPaymentsService } from '../../services/fn-supp-payments.service';
import { TransformDataTablePipe } from 'src/app/shared/Utils/transform-data-table.pipe';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FnConsolidatedService } from '../../services/fn-consoldate.service';

export interface PaymentsDetails {
  provider_name: string;
  cuit: string;
  idConsolidate: string;
  date: string;
  accNumber: string;
  amount: number;
}
@Component({
  selector: 'app-fn-payment-details',
  templateUrl: './fn-payment-details.component.html',
  styleUrls: ['./fn-payment-details.component.scss'],
})
export class FnPaymentDetailsComponent implements OnInit {
  detailsArray: any = [];
  invoicesArray: any = [];
  invoicesList: any = [];
  invoicesListCard: any = [];
  formatedInvoicesArray: any = [];
  dataMod!: any;
  idConsolidate?: string;
  cardMobiles: boolean = false;
  isConsolidated?: boolean;
  selectedInvoices: any[] = [];
  paymentId?: number;
  selectedItems: Set<any> = new Set();
  constructor(
    private translate: TranslateService,
    private transformDataTablePipe: TransformDataTablePipe,
    private consolidatedService: FnConsolidatedService,
    private paymentService: FnSuppPaymentsService,
    private dialogRef: MatDialogRef<FnPaymentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.getDetails();
    if (this.data.isConsolidatedEdited) {
      this.selectedInvoices = [...this.data.info.invoices];
      this.selectedInvoices.forEach((invoice) =>
        this.selectedItems.add(invoice)
      );
    }
  }

  loadSelectedItems(): void {
    const savedItems = localStorage.getItem('selectedInvoices');
    if (savedItems) {
      const savedArray: any[] = JSON.parse(savedItems);

      // Restablece el estado 'active' de cada invoice en base a lo que está guardado
      this.selectedInvoices.forEach((invoice) => {
        const savedItem = savedArray.find(
          (item) => item.invoiceId === invoice.invoiceId
        );
        if (savedItem) {
          invoice.active = savedItem.active; // Restaura el estado 'active'
        }
      });
    }
  }

  isItemSelected(item: any): boolean {
    return item.active;
  }

  toggleItemSelection(item: any): void {
    item.active = !item.active;
    this.saveSelectedItems();
  }

  saveSelectedItems(): void {
    const selectedIds = this.selectedInvoices.map((item) => ({
      invoiceId: item.invoiceId,
      active: item.active,
    }));

    localStorage.setItem('selectedInvoices', JSON.stringify(selectedIds));
  }

  getDetails() {
    if (this.data.isConsolidatedEdited && this.data.info) {
      this.dataMod = {
        provider_name: this.data.info.provider_name,
        cuit: this.data.info.cuit,
        // date: this.transformDataTablePipe.transform(
        //   this.data.info.paymentDate,
        //   'Date',
        //   ''
        // ),
        accNumber: this.data.info.accnumber,
        amount: this.data.info.amount,
        bank: this.data.info.bank,
        branch_number: this.data.info.branch_number,
        owner_name: this.data.info.owner_name
      };
      for (const key of Object.keys(this.dataMod)) {
        let detailsValues: any = [];

        const value = this.dataMod[key];
        if (key === 'invoices') continue;

        this.translate
          .get('IP.PAYMENTS.DETAILS.' + key.toUpperCase())
          .subscribe((translation: string) => {
            detailsValues.push({
              key: translation,
              value: value,
            });
          });

        this.detailsArray.push(detailsValues);
      }

      this.invoicesList = this.data.info.invoices;
    }
    if (!this.data.isConsolidatedEdited) {
      if (this.data.info.id) {
        this.consolidatedService
          .getConsolidateIdDetails(this.data.info.id)
          .subscribe({
            next: (response) => {
              console.log(response);
              
              this.dataMod = {
                provider_name: response.businessName,
                cuit: response.cuit,
                date: this.transformDataTablePipe.transform(
                  response.paymentDate,
                  'Date',
                  ''
                ),
                accNumber: response.accountNumber,
                amount: response.amount,
                bank: response.bank,
                branch_number: response.branchNumber,
                owner_name: response.ownerName,
                is_paid: response.isPaid
              };
              this.idConsolidate = response.idConsolidated?.toString();

              for (const key of Object.keys(this.dataMod)) {
                let detailsValues: any = [];

                const value = this.dataMod[key];
                if (key === 'invoices') continue;

                this.translate
                  .get('IP.PAYMENTS.DETAILS.' + key.toUpperCase())
                  .subscribe((translation: string) => {
                    detailsValues.push({
                      key: translation,
                      value: value,
                    });
                  });

                this.detailsArray.push(detailsValues);
              }
              this.selectedInvoices = response.invoices!;
            },
          });
      }
      if (!this.data.info.id) {
        this.dataMod = {
          provider_name: this.data.info.provider_name,
          cuit: this.data.info.cuit,
          date: this.transformDataTablePipe.transform(
            this.data.info.paymentDate,
            'Date',
            ''
          ),
          accNumber: this.data.info.accountNumber,
          amount: this.data.info.amount,
        };
        for (const key of Object.keys(this.dataMod)) {
          let detailsValues: any = [];

          const value = this.dataMod[key];
          if (key === 'invoices') continue;

          this.translate
            .get('IP.PAYMENTS.DETAILS.' + key.toUpperCase())
            .subscribe((translation: string) => {
              detailsValues.push({
                key: translation,
                value: value,
              });
            });

          this.detailsArray.push(detailsValues);
        }

        this.invoicesList = this.data.info.invoices;
      }
    }
    if (this.data.isConsolidatedEdited && !this.data.info) {
      this.paymentService.getPaymentDetail(this.data.id).subscribe({
        next: (data) => {
          this.dataMod = {
            provider_name: data.businessName,
            cuit: data.cuit,
            date: this.transformDataTablePipe.transform(
              data.paymentDate,
              'Date',
              ''
            ),
            accNumber: data.accountNumber,
            amount: data.amount,
          };
          this.invoicesArray = data.invoices;

          if (this.data.cardMobiles) {
            this.cardMobiles = true;
            //TODO guardar todos en un solo objeto y luego pushear a invoicesList;
            this.invoicesArray.forEach((invoice: any) => {
              let detailsInvoices: any[] = [];

              for (const key of Object.keys(invoice)) {
                detailsInvoices.push({
                  key: this.translate.instant(
                    'IP.PAYMENTS.DETAILS.INVOICES_TABLE.' + key.toUpperCase()
                  ),
                  value: invoice[key],
                });
              }
              this.invoicesListCard.push(detailsInvoices);
            });
          } else {
            this.invoicesList = data.invoices;
          }

          for (const key of Object.keys(this.dataMod)) {
            let detailsValues: any = [];

            const value = this.dataMod[key];
            if (key === 'invoices') continue;

            this.translate
              .get('IP.PAYMENTS.DETAILS.' + key.toUpperCase())
              .subscribe((translation: string) => {
                detailsValues.push({
                  key: translation,
                  value: value,
                });
              });
            this.detailsArray.push(detailsValues);
          }
        },
      });
    }
  }

  downloadPayDetails() {
    const modal = document.getElementById('modalToPDF');

    if (modal) {
      html2canvas(modal).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        const imgWidth = 190; // Ancho del contenido PDF
        const pageHeight = 295; // Altura de una página A4
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        let position = 0;

        pdf.addImage(imgData, 'PNG', 10, position + 10, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Manejo de contenido que exceda una página
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 10, position + 10, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save('modal-content.pdf');
      });
    } else {
      console.error('No se encontró el modal con el id especificado');
    }
  }

  isAmountKey(key: string): boolean {
    return (
      key === this.translate.instant('IP.PAYMENTS.DETAILS.AMOUNT') ||
      key ===
        this.translate.instant('IP.PAYMENTS.DETAILS.INVOICES_TABLE.AMOUNT')
    );
  }

  formatDateToMonthYearIntl(dateString: string): string {
    if (!dateString) {
      return '-';
    }
    const date = new Date(dateString);
    let formattedDate = Intl.DateTimeFormat('es-ES', {
      month: 'long',
      year: 'numeric',
    })
      .format(date)
      .replace(' de ', '/'); // Ajusta el formato "Abril de 2024" -> "Abril/2024"
    formattedDate =
      formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

    return formattedDate;
  }

  
  // payConsolidatedItem() {
  //   this.consolidatedService.payConsolidatedItem(this.data.info.id).subscribe({
  //     next: response => {
  //       console.log(response)
  //       this.dialogRef.close()
  //     }, 
  //     error: e => {
  //       console.log(e)
  //       this.dialogRef.close()
  //     }
  //   })
  // }
}
